module.exports = __webpack_public_path__ + "static/media/ts4cr0.e379ad49.png";